import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash.debounce';
import classnames from 'classnames';
import NavItem from './NavItem';
import { getWindowWidth } from '../scripts/utils';
var QuickNavBar = function QuickNavBar(_ref) {
  var _classnames;
  var _ref$quickNavBarItems = _ref.quickNavBarItems,
    quickNavBarItems = _ref$quickNavBarItems === void 0 ? [] : _ref$quickNavBarItems,
    closeMenu = _ref.closeMenu,
    isClub = _ref.isClub,
    isLoggedIn = _ref.isLoggedIn,
    forceShowRevenue = _ref.forceShowRevenue,
    locale = _ref.locale;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    spillOverNavItems = _useState2[0],
    setSpillOverNavItems = _useState2[1];
  var navItemsShown = [];
  var navItemsSpillOver = [];
  useEffect(function () {
    var prevWindowWidth = 0;
    var resetSpillOverNavItems = function resetSpillOverNavItems() {
      var currentWindowWidth = getWindowWidth();
      if (currentWindowWidth >= 1024 && currentWindowWidth > prevWindowWidth + 2) {
        var primaryNav = document.querySelector('.header__nav-top__nav-container__primary');
        if (primaryNav && !primaryNav.classList.contains('resizing')) {
          primaryNav.classList.add('resizing');
        }
        setSpillOverNavItems({});
      }
      prevWindowWidth = currentWindowWidth;
    };
    var removeOverflowHidden = function removeOverflowHidden() {
      var primaryNav = document.querySelector('.header__nav-top__nav-container__primary');
      if (primaryNav && primaryNav.classList.contains('resizing')) {
        primaryNav.classList.remove('resizing');
      }
    };

    //fixes nav items dropping down issue when user has a plugged in mouse and the scrollbars appear on a page that renders client-side (e.g. /standings)
    var reflowCount = 0;
    var reflowMaxCount = 3;
    var reflow = setInterval(function () {
      var _window$document$docu = window.document.documentElement,
        scrollHeight = _window$document$docu.scrollHeight,
        clientHeight = _window$document$docu.clientHeight;
      if (scrollHeight > clientHeight || reflowCount >= reflowMaxCount) {
        if (typeof Event === 'function') {
          // modern browsers
          window.dispatchEvent(new Event('resize'));
        } else {
          // for IE and other old browsers
          // causes deprecation warning on modern browsers
          var evt = window.document.createEvent('UIEvents');
          evt.initUIEvent('resize', true, false, window, 0);
          window.dispatchEvent(evt);
        }
        clearInterval(reflow);
      }
      reflowCount++;
    }, 1000);
    window.addEventListener('resize', _debounce(resetSpillOverNavItems));
    window.addEventListener('resize', _debounce(removeOverflowHidden, 1000));
    return function () {
      window.removeEventListener('resize', _debounce(resetSpillOverNavItems));
      window.removeEventListener('resize', _debounce(removeOverflowHidden, 1000));
    };
  }, []);
  quickNavBarItems.forEach(function (item) {
    if (spillOverNavItems[item.id]) {
      navItemsSpillOver.push(item);
    } else {
      navItemsShown.push( /*#__PURE__*/React.createElement(NavItem, {
        key: item.id,
        className: "header__nav-top__nav-item",
        closeMenu: closeMenu,
        navItem: item,
        isClub: isClub,
        isLoggedIn: isLoggedIn,
        locale: locale,
        setSpillOverNavItems: setSpillOverNavItems
      }));
    }
  });
  var spillOverParentNavItem = {
    id: 'spillover-nav-items',
    text: 'MORE',
    subnav: navItemsSpillOver
  };
  var quickNavTopClasses = classnames((_classnames = {}, _defineProperty(_classnames, 'header__nav-top__nav-items', true), _defineProperty(_classnames, 'header__nav-top__nav-items--quick', true), _defineProperty(_classnames, 'header__nav-top__nav-items--quick--show-revenue', forceShowRevenue), _classnames));
  return /*#__PURE__*/React.createElement("div", {
    className: "header__nav-top__nav-container__primary"
  }, /*#__PURE__*/React.createElement("nav", {
    className: quickNavTopClasses,
    onMouseEnter: closeMenu
  }, /*#__PURE__*/React.createElement("ul", {
    className: "header__nav-top__nav-items--secondary",
    "aria-label": "Secondary Navigation"
  }, navItemsShown)), /*#__PURE__*/React.createElement("nav", {
    className: "header__nav-top__nav-items header__nav-top__nav-items--spillover",
    onMouseEnter: closeMenu
  }, navItemsSpillOver.length > 0 && /*#__PURE__*/React.createElement("ul", {
    "aria-label": "Spillover Navigation"
  }, /*#__PURE__*/React.createElement(NavItem, {
    key: spillOverParentNavItem.id,
    className: "header__nav-top__nav-item",
    closeMenu: closeMenu,
    navItem: spillOverParentNavItem,
    isClub: isClub,
    locale: locale
  }))));
};
export default QuickNavBar;
QuickNavBar.propTypes = {
  closeMenu: PropTypes.func.isRequired,
  locale: PropTypes.string,
  isClub: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  quickNavBarItems: PropTypes.instanceOf(Array).isRequired,
  forceShowRevenue: PropTypes.bool
};